import { checkRegistrationForErrors } from "./checkRegistrationForm";
import { submitRegistrationForm } from "./submitRegistrationForm";
import { submitRegistrationFormAndBuy } from "./submitRegistrationFormAndBuy";


export function loadRegistration(){
    $(".submit-reg").on("click", function(e){
        e.preventDefault()
        const returns = checkRegistrationForErrors();
        if (!returns.errors){
    
            let code:boolean|string = false;
            const activationCode = $("#activation-code");
            console.log(activationCode);
            if (activationCode !== undefined){
                code = activationCode.val().toString();
            }
    
            let newsletter = 0;
            const newsletterChoice = $("#newsletter");
            if (newsletterChoice !== undefined){
                newsletter = (newsletterChoice.is(":checked")) ? 1 : 0;
            }
    
            submitRegistrationForm(returns.vorname, returns.nachname, returns.email, returns.password, code, newsletter, $(this));
        }
    });

    $(".submit-reg-buy").on("click", function(e){
        e.preventDefault()
        const returns = checkRegistrationForErrors();
        if (!returns.errors){
    
            let code:boolean|string = false;
            const activationCode = $("#activation-code");
            console.log(activationCode)
            if (activationCode.length > 0){
                code = activationCode.val().toString()
            }

            const product = $(this).attr('data-product')
    
            let newsletter = 0;
            const newsletterChoice = $("#newsletter");
            if (newsletterChoice !== undefined){
                newsletter = (newsletterChoice.is(":checked")) ? 1 : 0;
            }
    
            submitRegistrationFormAndBuy(returns.vorname, returns.nachname, returns.email, returns.password, product, newsletter, $(this));
        }
    });
}